import { motion } from "framer-motion"
import { useCallback, useEffect, useRef, useState } from "react"
import ReactDOM from "react-dom"

const LaunchAnimator = ({ rect, onDone, PreviewComponent }) => {
  const target = {
    top: 0,
    left: 0,
    width: window.innerWidth,
    height: window.innerHeight
  }

  return (
    <motion.div
      className="LaunchAnimator"
      children={PreviewComponent && <PreviewComponent />}
      initial={{
        x: 0,
        top: rect.top,
        left: rect.left,
        width: rect.width,
        height: rect.height,
        borderRadius: 20
      }}
      animate={{
        x: 1,
        top: target.top,
        left: target.left,
        width: target.width,
        height: target.height,
        borderRadius: 0
      }}
      transition={{ type: "spring", stiffness: 250, damping: 20 }}
      style={{
        zIndex: 999999999,
        position: "fixed",
        backgroundColor: !PreviewComponent && "whitesmoke",
        transform: "translateZ(0)",
        overflow: "hidden"
      }}
      onAnimationComplete={onDone}
    />
  )
}

const withLauncher = (options) => {
  // Allowing for options to be a component or set of components.
  const {
    Component: ComposedComponent,
    Preview: PreviewComponent,
    Preload: PreloadComponent
  } = options.Component
    ? options
    : {
        Component: options
      }

  const defaultState = {
    show: false,
    rect: null,
    to: null
  }

  const Launcher = (props) => {
    const launcherRef = useRef(null)
    const mountedRef = useRef(false)
    const [state, setState] = useState(defaultState)

    useEffect(() => {
      mountedRef.current = true
      return () => {
        mountedRef.current = false
      }
    }, [])

    const handleDone = useCallback(
      (to) => {
        // FIXME: better way to do this
        if (window.App) window.App.navigate(to)
        if (typeof props.onLaunched === "function") props.onLaunched(to)
        if (mountedRef.current) setState(defaultState)
      },
      [props.onLaunched]
    )

    const handleLaunch = useCallback(
      async (to) => {
        // const rect = launcherRef.current?.getBoundingClientRect()
        // if (!rect) {
        //   return
        // }

        if (
          PreloadComponent &&
          typeof PreloadComponent.preload === "function"
        ) {
          await PreloadComponent.preload()
        }

        if (!mountedRef.current) {
          return
        }

        // setState({
        //   to,
        //   rect,
        //   show: true
        // })

        handleDone(to)
      },
      [handleDone]
    )

    return (
      <>
        <ComposedComponent {...props} onLaunch={handleLaunch} />
        {state.show
          ? ReactDOM.createPortal(
              <LaunchAnimator
                // rect={state.rect}
                PreviewComponent={PreviewComponent}
                onDone={() => handleDone(state.to)}
              />,
              document.body
            )
          : null}
      </>
    )
  }

  Launcher.displayName = "Launcher"

  return Launcher
}

export default withLauncher
